import { render, staticRenderFns } from "./LabelBatchStatusFilter.vue?vue&type=template&id=56811de4&"
import script from "./LabelBatchStatusFilter.vue?vue&type=script&lang=js&"
export * from "./LabelBatchStatusFilter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports